import { createApp } from 'vue'
import App from './App.vue'

document.addEventListener("turbo:load", () => {
  const mountEl = document.querySelector("#eat-slider");
  if (mountEl){
    const app = createApp(App, mountEl.dataset)
    app.mount('#eat-slider')
  }


});

